var exports = {
  "Qs": "KeyboardShortcutsCheatsheetModal.module__content___VFNHdj",
  "V0": "KeyboardShortcutsCheatsheetModal.module__sections___VFNHdj",
  "uW": "KeyboardShortcutsCheatsheetModal.module__section___VFNHdj",
  "Gf": "KeyboardShortcutsCheatsheetModal.module__sectionTitle___VFNHdj",
  "wE": "KeyboardShortcutsCheatsheetModal.module__shortcutRows___VFNHdj",
  "J8": "KeyboardShortcutsCheatsheetModal.module__shortcutRow___VFNHdj",
  "hV": "KeyboardShortcutsCheatsheetModal.module__shortcutLabel___VFNHdj",
  "PU": "KeyboardShortcutsCheatsheetModal.module__chipGroups___VFNHdj",
  "al": "KeyboardShortcutsCheatsheetModal.module__chipGroup___VFNHdj",
  "jw": "KeyboardShortcutsCheatsheetModal.module__chip___VFNHdj",
};

module.exports = exports;
